import {ACTION_TYPES} from 'Utils/constants';

const setTakeMeThereEventId = data => ({
    type: ACTION_TYPES.SET_TAKE_ME_THERE_EVENT_ID,
    data,
});

export default setTakeMeThereEventId;
